<template>
  <main class="blank-layout">
    <router-view />
  </main>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.blank-layout {
  height: 100%;
}
</style>
